import React from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Frites from './components/Frites';
import Savoir from './components/Savoir';
import Formulaire from './components/Formulaire';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NavBar from './components/NavBar';
import Carousel from './components/Caroussel';
import MentionsLegales from './components/MentiosLegales';
import ScrollToTopButton  from './components/ScrollToTopButton'

import photo1 from './asset/image/phot1.jpg';
import photo2 from './asset/image/photo2.jpg';
import photo3 from './asset/image/photo3.jpg';
import photo4 from './asset/image/photo4.jpg'
import Temoignages from './components/Temoignages';
import Faq from './components/Faq';
// import Actualites from './components/Actualites';
import Accueil from './components/Accueil';

const photos = [
  { src: photo1, alt: 'Photo 1', caption: 'Notre food truck en action' },
  { src: photo2, alt: 'Photo 2', caption: 'Evènement privé' },
  { src: photo3, alt: 'Photo 3', caption: 'Base de loisir' },
  { src: photo4, alt: 'Photo4', caption: 'Le food truck, prêt, on vous attends!' }
];

function App() {
  return (
    <Router basename="/">
      {/* <Header /> */}
      <NavBar />
      <Routes basename="/">
        <Route path="/" element={
          <>
          <section id='accueil'>
            <Accueil />
          </section>
            {/* <section id="galerie">
              <h2>Galerie Photos</h2>
              <Carousel images={photos} />
            </section> */}
            <section id="a-propos">
              <Frites />
            </section>
            <section id="savoir"> 
              <Savoir />
            </section>
            <section id='temoignages'>
              <Temoignages/>
            </section>
            <section id='faq'>
              <Faq/>
            </section>
            {/* <section id='actualites'>
              <Actualites/>
            </section> */}
            <section id="contacts">
              <Formulaire />
            </section>
          </>
        } />
        <Route path="/mentions-legales" element={<MentionsLegales />} basename="/" />
      </Routes>
      <Footer />
      <ScrollToTopButton />
    </Router>
  );
}

export default App;
